<div>
    <app-nav-header ></app-nav-header>
    <app-search *ngIf="isSearching"></app-search>
    <app-side-nav *ngIf="showSideNav"></app-side-nav>
    <main [ngClass]="{'logged-in': loggedIn || isPreview}">
        <router-outlet></router-outlet>
    </main>
</div>